module.exports = __webpack_public_path__ + "img/linked.a3e9115c.png";